var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.06689C5.68896 7.06689 5.42871 6.95264 5.16846 6.69238L0.471191 1.88721C0.280762 1.69043 0.185547 1.46191 0.185547 1.18896C0.185547 0.624023 0.63623 0.166992 1.19482 0.166992C1.47412 0.166992 1.73438 0.28125 1.94385 0.490723L6.00635 4.68018L10.0625 0.490723C10.272 0.28125 10.5322 0.166992 10.8052 0.166992C11.3638 0.166992 11.8145 0.624023 11.8145 1.18896C11.8145 1.46826 11.7192 1.69678 11.5288 1.88721L6.83154 6.69238C6.58398 6.94629 6.31738 7.06689 6 7.06689Z",
    fill: "#5A5976"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDark);
export default __webpack_public_path__ + "static/media/arrow-dark.b8b2d4b7987d17256852feed4442c110.svg";
export { ForwardRef as ReactComponent };